import React, { useState } from 'react'
import { MdKeyboardArrowRight, MdOutlineExpandMore } from 'react-icons/md';
import { IoMdCheckmark } from 'react-icons/io';
import { useShop } from '../../../Providers/ShopProvider';

const ProductSuppliersFilter = () => {
    const { suppliers, productsFilter, setProductsFilter } = useShop()
    const [showContent, setShowContent] = useState(true)

    const handleSelectUnSelectFilter = (id, name) => {
        setProductsFilter(prev => {
            const currentSuppliers = prev.Suppliers || []
            if (currentSuppliers.some(o => o.supplierId === id)) {
                return {
                    ...prev,
                    Suppliers: currentSuppliers.filter(item => item.supplierId !== id)
                }
            } else {
                return {
                    ...prev,
                    Suppliers: [...currentSuppliers, { supplierId: id, supplierName: name }]
                }
            }
        })
    }

    return (
        <div className='feature'>
            <div className='feature-name row' onClick={() => setShowContent(!showContent)}>
                <div className='col'>{'Producent'}</div>
                <div className='col-auto expandMore-icon' >{showContent ? <MdOutlineExpandMore size={25} /> : <MdKeyboardArrowRight size={25} />}</div>
            </div>
            <div className={showContent ? 'feature-values show' : 'feature-values'}>
                {suppliers.length > 0 &&
                    suppliers.filter(p => p.artCount > 0).map((item, key) => {
                        let isChecked = productsFilter.Suppliers.some(o => o.supplierId === item.supplierId)
                        return (
                            // <div className="d-flex align-items-center mb-2" key={key}>
                            //     <div className={`checkbox me-2 ${isChecked ? 'checked' : 'unchecked'}`} onClick={() => handleSelectUnSelectFilter(item.supplierId, item.supplierName)}>
                            <div className=" feature-value row align-items-center" key={key}>
                                <div className={`col-1 checkbox ${isChecked ? 'checked' : 'unchecked'}`} onClick={() => handleSelectUnSelectFilter(item.supplierId, item.supplierName)}>
                                    {isChecked && (
                                        <span className="checkmark">
                                            <IoMdCheckmark />
                                        </span>
                                    )}
                                </div>
                                {/* <div className="user-select-none flex-grow-1 d-flex align-items-center "> */}
                                <div className="col-auto user-select-none">
                                    {/* {item.supplierName.charAt(0).toUpperCase() + item.supplierName.slice(1).toLowerCase()} */}
                                    {item.supplierName}
                                    <span className='ms-1 secondary-text '>{'(' + item.artCount + ')'}</span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default ProductSuppliersFilter